<template>
  <div class="mobile-onboard">
    <div class="instructions" v-if="currentPage <= lastPage">
      <div class="header">
        <div class="welcome">
          Welcome to <span class="drip">Driphound </span>
        </div>
      </div>
      <div class="main">
        <div class="onboard-pages">
          <div class="video-box">
            <video
              v-show="currentPage == 1"
              autoplay
              preload
              loop
              muted
              playsinline
              poster="../assets/mobilefollowposter.jpg"
            >
              <source src="../assets/mobilefollow.mp4" type="video/mp4" />
              <source src="../assets/mobilefollow.webm" type="video/webm" />
            </video>
            <video
              v-show="currentPage == 2"
              autoplay
              preload
              loop
              muted
              playsinline
              poster="../assets/mobilealertsposter.jpg"
            >
              <source src="../assets/mobilealerts.mp4" type="video/mp4" />
              <source src="../assets/mobilealerts.webm" type="video/webm" />
            </video>
            <video
              v-show="currentPage == 3"
              autoplay
              preload
              loop
              muted
              playsinline
              poster="../assets/mobiledirectposter.jpg"
            >
              <source src="../assets/mobiledirect.mp4" type="video/mp4" />
              <source src="../assets/mobiledirect.webm" type="video/webm" />
            </video>
          </div>
          <div class="subtitle">
            {{ subtitle }}
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="left">
          <div
            class="back-btn btn"
            v-show="currentPage > 1"
            @click="currentPage--"
          >
            Back
          </div>
        </div>
        <div class="center">
          <div class="dots">
            <div
              class="dot"
              v-for="page in lastPage"
              :key="page"
              :class="{ active: page == currentPage }"
            ></div>
          </div>
        </div>
        <div class="right">
          <div
            class="next-btn btn"
            :class="{ lastpage: isLastPage }"
            @click="currentPage++"
          >
            {{ nextButtonText }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <onboard />
    </div>
  </div>
</template>

<script>
import Onboard from "./Onboard.vue";
export default {
  name: "MobileOnboard",
  components: {
    Onboard,
  },
  data() {
    return {
      currentPage: 1,
      lastPage: 3,
    };
  },
  computed: {
    isLastPage() {
      return this.currentPage == this.lastPage;
    },
    nextButtonText() {
      if (this.isLastPage) {
        return "Get started";
      } else {
        return "Next";
      }
    },
    subtitle() {
      if (this.currentPage == 1) {
        return "Follow artists to browse official merch tailored to your taste";
      } else if (this.currentPage == 2) {
        return "Get notified about new drops before they sell out";
      } else if (this.currentPage == 3) {
        return "Buy direct from the artist to support their work";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-onboard {
  display: flex;
  flex-direction: column;
  flex: 1;
  color: white;
  background-color: #509bf5;
  background-image: linear-gradient(90deg, #1f637985 0%, #552f6da8 80%);
  .header {
    text-align: center;
    .welcome {
      margin-top: 15px;
      margin-bottom: 22px;
      font-size: 2em;
      line-height: 1.2;
      vertical-align: middle;
      color: white;
    }
  }
  .main {
    flex: 1;
    display: flex;
    padding: 0 15px;
  }
  .footer {
    height: 70px;
    display: flex;
    padding: 0 12px;
    flex-direction: row;
    align-items: center;
    .left {
      min-width: 101px;
      width: 101px;
    }
    .center {
      flex: 1;
      justify-content: center;
      display: flex;
      .dots {
        flex: 1;
        justify-content: center;
        display: flex;
        .dot {
          border-radius: 50%;
          background: #333;
          height: 7px;
          width: 7px;
          margin: 0 2px;
          &.active {
            background: white;
          }
        }
      }
    }
    .right {
      min-width: 101px;
      width: 101px;
      justify-content: flex-end;
      display: flex;
    }
  }
}

.onboard-pages {
  width: 100%;
}
.last-page {
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  display: flex;
  flex-direction: column;
  max-width: 450px;
  .text {
    color: white;
    font-size: 18px;
    text-align: center;
    margin-bottom: 12px;
    line-height: 25px;
  }
  .start-btn {
    border-radius: 20px;
    background: #1db854;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
    padding: 9px 30px 11px;
    color: #fff;
    cursor: pointer;
  }
}

.instructions {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.subtitle {
  color: white;
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  line-height: 25px;
}
.video-box {
  display: flex;
  flex: 1;
  height: 55vh;
  margin-top: 20px;
  video {
    width: 100%;
    height: 100%;
  }
}
.next-btn {
  &.lastpage {
    background: white;
    color: black;
  }
}

.btn {
  font-size: 15px;
  color: white;
  border: 1px white solid;
  border-radius: 4px;
}
.drip {
  font-family: "Nosifer", cursive;
  font-size: 1.8rem;
  vertical-align: middle;
  text-decoration: none;
}
</style>
